export let getStackTrace = () => {
  const error = new Error();
  return error.stack;
};
